<div class="w-full h-fit
            mt-16 lg:mt-32 bg-white
            overflow-y-auto overflow-x-hidden">

  <div class="w-full flex flex-col">
    <!--  Top Section  -->
    <div *ngIf="!isSmallScreen" class="w-full bg-white
                    p-[0.938rem]">
      <div class="w-full max-w-container
                    mx-auto flex
                    flex-row flex-nowrap
                    justify-between items-center">
        <h2 class="text-lg text-darker
                    font-semibold">
          Over de {{ package?.packageName | capitalizeFirst }}
        </h2>

        <div class="hidden md:flex
                    gap-x-1.5 justify-end">
                    <span [routerLink]="['/']"
                          class="cursor-pointer hover:text-primary text-secondary-gray">
                      Home /
                    </span>


          <span [routerLink]="['/schoonmaakdiensten']"
                class="cursor-pointer hover:text-primary text-secondary-gray">
            Schoonmaak Diensten /
          </span>

          <span class="text-darker">
            {{ package?.packageName | capitalizeFirst }}
          </span>
        </div>
      </div>
    </div>

    <div class="w-full h-full
                min-h-background
                md:min-h-lg-background
                max-[768px]:max-h-background
                md:max-h-lg-background
                xl:max-h-[52.438rem]
                xl:min-h-[44.625rem]
                group cursor-text
                bg-local bg-no-repeat
                bg-cover flex bg-bottom
                bg-[url('https://firebasestorage.googleapis.com/v0/b/schoonmaakwoede-productie.appspot.com/o/images%2FSchoonmaak_per_uur.jpeg?alt=media&token=a88cab30-3c21-4626-9224-599c37c5e025')]">
      <div class="w-full h-full
                  max-w-container mx-auto
                  xl:my-auto 2xl:mb-0
                  p-[0.938rem] xl:px-0"
           [class.mt-auto]="package?.packageId">
        <div class="w-full max-w-[62.5rem]
                    min-h-fit px-6 py-4
                    bg-blur rounded-[2.25rem]
                    mx-auto mt-auto">
          <div class="w-full max-w-[44rem]
                    flex flex-col py-[1.25rem]
                    justify-center mx-auto
                    gap-y-7 items-center
                    md:text-center">
            <h1 class="w-full text-[1.625rem]
                      text-dark-blue leading-[2.113rem]
                      md:leading-[3.9rem]
                      md:text-5xl font-semibold">
              {{ package?.packageName | capitalizeFirst }}
            </h1>

            <div class="w-full flex
                      gap-y-[1rem]
                      justify-between flex-wrap
                      text-left text-darker">
              <div class="w-full md:w-1/2
                        flex flex-col gap-4">
                <div class="w-full flex gap-2">
                  <img src="assets/icons/bullet.svg" alt="bullet"/>

                  <span>Binnen drie minuten besteld</span>
                </div>

                <div class="w-full flex gap-2">
                  <img src="assets/icons/bullet.svg" alt="bullet"/>

                  <span>Bekend van TV en landelijke media</span>
                </div>
                <div class="w-full flex gap-2">
                  <img src="assets/icons/bullet.svg" alt="bullet"/>

                  <span>Bereken snel je voorrijkosten</span>
                </div>
              </div>

              <div class="w-full md:w-1/2
                        flex flex-col gap-4">
                <div class="w-full flex gap-2">
                  <img src="assets/icons/bullet.svg" alt="bullet"/>

                  <span>100% tevredenheidsgarantie</span>
                </div>

                <div class="w-full flex gap-2">
                  <img src="assets/icons/bullet.svg" alt="bullet"/>

                  <span>We komen overal in België</span>
                </div>
                <div class="w-full flex gap-2">
                  <img src="assets/icons/bullet.svg" alt="bullet"/>
                  <span>Betaal enkel voorrijkosten en uren</span>
                </div>
              </div>
            </div>

            <!--  Postcode   -->
            <form [formGroup]="zipCodeForm"
                  #form=ngForm
                  (ngSubmit)="onStart(form)"
                  class="h-12 w-min-fit
                       -mb-3.5 md:mb-0
                       w-full relative
                       flex flex-nowrap
                       rounded-full shadow
                       ring-2 ring-transparent
                       hover:ring-primary
                       focus:ring-primary
                       group-hover:ring-primary
                       focus-within:ring-primary"
                  [ngClass]="{ '!ring-[#ef4444]': zipCodeForm.get('zipCode')?.invalid && (zipCodeForm.get('zipCode')?.touched || form?.submitted) }">
              <input class="bg-white appearance-none
                          border-none outline-none
                          w-full rounded-l-full
                          p-[0.938rem] text-darker
                          placeholder:text-placeholder"
                     formControlName="zipCode"
                     placeholder="Je postcode"/>

              <button type="submit"
                      class="flex items-center
                                       w-fit h-full
                                       border border-primary
                                       outline-none appearance-none
                                       px-3 md:px-9 shadow-primary
                                       whitespace-nowrap
                                       text-center text-white
                                       cursor-pointer ripple
                                       rounded-r-full bg-primary">
                Plan nu
              </button>
            </form>
            <!--  Postcode  -->

          </div>
        </div>
      </div>
    </div>
    <div class="w-full max-w-container
                flex flex-wrap mx-auto
                justify-between p-[0.938rem]">
      <div class="w-full lg:w-1/2
                  lg:pr-14 mt-12">
        <div class="w-full h-fit
                            flex flex-col mb-4">
          <div class="w-full text-2xl
                      text-darker font-semibold">
            Voor wie is deze dienst ?
          </div>

          <div class="h-1 w-32
                      bg-divider my-[0.938rem]"></div>

          <div class="w-full text-lg
                      leading-[1.688rem] text-gray">
            {{ package?.description }}
          </div>
        </div>

        <div class="w-full flex text-darker
                    flex-col md:flex-row
                    text-xl mt-8
                    justify-between flex-wrap
                    gap-[0.625rem] text-left">
          <div *ngFor="let item of package?.bulletPoints" class="w-full flex gap-4">
            <img class="w-3"
                 src="assets/icons/arrow.svg"
                 alt="arrow"/>

            <span>{{ item }}</span>
          </div>

          <div class="w-full text-[1.125rem]
                      text-gray my-4">
            Dan is de Schoonmaak per uur het maat pakket voor jou!
          </div>

          <div class="w-full">
            <button (click)="onOpenLink()"
                    type="button"
                    class="flex items-center
                           w-fit shadow font-semibold
                           px-[4.25rem] py-[0.938rem]
                           whitespace-nowrap text-[1.125rem]
                           text-center text-white
                           cursor-pointer ripple
                           rounded-full bg-primary">
              Plan direct
            </button>
          </div>
        </div>

      </div>

      <div class="w-full lg:w-1/2
                        lg:pl-14 mt-12
                        flex flex-col gap-4">
        <div class="w-full text-darker
                            text-2xl font-semibold">
          Heeft u liever een Pakket?
        </div>

        <div class="h-1 w-32 flex md:hidden
                            bg-divider"></div>

        <div class="w-full text-[1.125rem] text-gray">
          De werkzaamheden zijn vooraf beschreven en u heeft een vaste prijs.
        </div>

        <div class="w-full flex items-center my-4">
          <button type="button"
                  [routerLink]="['/schoonmaakdiensten']"
                  class="flex items-center
                         w-fit shadow font-semibold
                         px-[4.25rem] py-[0.938rem]
                         whitespace-nowrap text-[1.125rem]
                         cursor-pointer text-primary
                         border border-primary
                         ripple ripple-white
                         rounded-full bg-transparent">
            Bekijk Pakketten
          </button>
        </div>
      </div>
    </div>

  </div>

  <!--  Body  -->
  <div class="w-full max-w-container
            flex flex-wrap
            mt-[2.813rem] mb-12
            md:mt-[7.188rem]
            justify-between mx-auto">
    <div class="w-full mx-auto
              flex flex-col
              p-[0.938rem]
              gap-2 md:text-center">
      <div class="w-full text-2xl
                leading-[2.25rem]
                md:text-[2.375rem]
                md:leading-[3.563rem]
                text-darker font-semibold">
        Wat kun je verwachten bij een {{ package?.packageName | capitalizeFirst }}?
      </div>

      <div class="h-1 w-32
                bg-divider md:mx-auto
                mt-[0.9rem] md:my-[1rem]"></div>

      <div class="w-full text-gray ">
        Kies je voor onze maat schoonmaak, dan kies je voor volledige controle over de schoonmaakwerkzaamheden in
        jouw ruimte. Op het moment dat het jou uitkomt, staan onze deskundige schoonmaakspecialisten voor de deur,
        uitgerust met alle nodige middelen en materialen. Jij bepaalt welke taken er worden uitgevoerd, waardoor de
        dienst naadloos aansluit op jouw persoonlijke wensen.
      </div>
      <div class="w-full text-gray">
        Deze service biedt je de flexibiliteit die je nodig hebt, zonder onverwachte verrassingen of extra kosten
        achteraf. Je betaalt alleen de voorrijkosten en voor de tijd die onze schoonmakers daadwerkelijk actief zijn in jouw ruimte. Het
        maakt niet uit of je een grondige reiniging van bepaalde kamers wenst of dat je specifieke gebieden aangepakt
        wilt hebben die extra aandacht vereisen; ons team volgt jouw instructies op de voet.
      </div>
      <div class="w-full text-gray ">
        Met deze persoonlijke en flexibele aanpak zorgen we ervoor dat je woon- of werkplek niet alleen voldoet aan jouw
        schoonmaakstandaarden maar deze zelfs overtreft. Onze maat schoonmaak is dé oplossing voor iedereen die een
        dynamische levensstijl heeft en op zoek is naar een schoonmaakdienst die zich volledig aanpast aan individuele
        behoeften en verwachtingen.
      </div>

    </div>
  </div>
  <div class="w-full bg-primary
    p-[0.938rem]                    text-white md:py-12                   ">
    <sw-zip-code [customBackground]="true"></sw-zip-code>
  </div>

  <div class="w-full max-w-container
                flex flex-wrap
                justify-between mx-auto
                p-[0.938rem] mt-[2.813rem]
                md:mt-[7.188rem]">
    <div class="w-full
                        flex flex-col
                        mx-auto md:mb-3.5
                        gap-2 md:text-center">
      <div class="w-full text-2xl
                            leading-[2.25rem]
                            md:text-[2.375rem]
                            md:leading-[3.563rem]
                            text-darker font-semibold">
        Schoonmaakwoede aan het werk
      </div>

      <div class="h-1 w-32
                            bg-divider md:mx-auto
                            my-[0.9rem] md:my-[1rem]"></div>
    </div>
  </div>
  <sw-video></sw-video>

  <sw-ratings></sw-ratings>

  <div class="w-full h-[36rem] md:h-[50rem]
       bg-[url('https://firebasestorage.googleapis.com/v0/b/schoonmaakwoede-productie.appspot.com/o/images%2Fwie_is_schoonmaakwoede_mobiel.jpeg?alt=media&token=0920703c-6716-43cb-8c40-0fe508445dd9')]
  md:bg-[url('https://firebasestorage.googleapis.com/v0/b/schoonmaakwoede-productie.appspot.com/o/images%2Fwie_wat_schoonmaakwoede_doet.jpeg?alt=media&token=51799de5-2058-4a4a-a0d2-f1fff43602aa')]
  bg-no-repeat
  bg-cover
  bg-bottom
  md:bg-right-bottom
  p-[0.938rem]
  flex flex-col">
    <div class="w-full max-w-[45rem]
                min-h-fit p-8 px-6
                sm:p-16 mt-auto
                lg:px-20 lg:py-28
                bg-blur rounded-[2.25rem]
                md:ml-auto md:my-auto">
      <div class="w-full
                  flex flex-col
                  gap-4 md:gap-8">
        <div class="w-full text-2xl sm:text-4xl
                            text-white font-semibold">
          Schoonmaakwoede. Wie we zijn en wat we doen.
        </div>

        <div class="h-1 w-32
                            opacity-30 bg-white
                            hidden md:flex"></div>

        <div class="w-full text-white
                            leading-[1.6rem]
                            text-[1rem] opacity-70">
          Onze naam staat voor perfectie in grondige schoonmaak. Laat je ontzorgen en ervaar het gevoel van
          een heerlijk proper huis of bedrijf. Of het nu gaat om een groot of een klein project, wij
          garanderen een blinkend resultaat. Waar ook in België. Ons unieke online begrotings- en
          bestelsysteem maakt het makkelijk.
        </div>
      </div>
    </div>
  </div>

<!--  <sw-media-wizard></sw-media-wizard>-->

  <!--  Body  -->
</div>
